import React from "react";
import ReactDOM from "react-dom";
import App from './App';
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";
import { DarkTheme, LightTheme } from './theme';

import * as serviceWorker from './serviceWorker';
import './i18n/i18n';


const Root = () => {
  const useDark = true;

  const theme = React.useMemo(() =>
    useDark ? DarkTheme : LightTheme,
    [useDark],
  );
  return <ThemeProvider theme={theme}>
    <CssBaseline />
      <App />
  </ThemeProvider>
}

const renderApplication = () => {
  ReactDOM.render(<Root />, document.getElementById("root"));
}

renderApplication();

serviceWorker.register();